// extracted by mini-css-extract-plugin
export var imgSquare = "survey-option-square-module--img-square--i5gS3";
export var imgWrapper = "survey-option-square-module--img-wrapper--eGb7N";
export var labelText = "survey-option-square-module--label-text--ONWLN";
export var labelTextWrapper = "survey-option-square-module--label-text-wrapper--zOSig";
export var squareIcon = "survey-option-square-module--square-icon--9LyFZ";
export var squareInput = "survey-option-square-module--square-input--uMNlP";
export var squareOption = "survey-option-square-module--square-option--6oZKC";
export var squareWrapper = "survey-option-square-module--square-wrapper--Tb+KN";